import HTTP from '../common/http-common';
const END_POINT = '/log';

const list = () => HTTP.get(END_POINT);

export {
    list
}